import ApiService from '@/services/api.service'
import { orderBy } from 'lodash'

// action types
export const GET_RESTAURANTS = 'getRestaurants'
export const GET_FEATURED_RESTAURANTS = 'getFeaturedRestaurants'
export const GET_RESTAURANT = 'getRestaurant'

// mutation types
export const SET_RESTAURANTS = 'setRestaurants'
export const SET_FEATURED_RESTAURANTS = 'setFeaturedRestaurants'
export const SET_RESTAURANT = 'setRestaurant'
export const SET_ERROR = 'setError'

const state = {
  errors: null,
  restaurants: [],
  featuredRestaurants: [],
  currentRestaurant: {},
}

const getters = {
  restaurants(state) {
    return state.restaurants
  },
  featuredRestaurants(state) {
    return state.featuredRestaurants
  },
  currentRestaurant(state) {
    return state.currentRestaurant
  },
}

const actions = {
  [GET_RESTAURANTS](context, payload) {
    return new Promise((resolve) => {
      ApiService.get('/get-data/restaurants', '', payload)
        .then(({ data }) => {
          context.commit(SET_RESTAURANTS, data.data)
          resolve(data)
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors)
        })
    })
  },
  [GET_FEATURED_RESTAURANTS](context, payload) {
  return new Promise((resolve) => {
    ApiService.get('/get-data/restaurants', '', payload)
      .then(({ data }) => {
        // data.data jer backend sada vraća { data: [...], total }
        const items = Array.isArray(data?.data) ? data.data : []

        // umesto === 1 koristi truthy/normalizaciju
        const featured = items.filter(
          r => r.featured === true || r.featured === 1 || r.featured === '1'
              || r.featured === 'true' || r.featured === 'True'
        )

        context.commit(
          SET_FEATURED_RESTAURANTS,
          orderBy(featured, o => o.featured_position ?? 9999, 'asc')
        )
        resolve(data)
      })
      .catch(({ response }) => {
        context.commit(SET_ERROR, response?.data?.errors)
      })
  })
},
  [GET_RESTAURANT](context, payload) {
    return new Promise((resolve) => {
      ApiService.get('/get-data/restaurants', payload.slug, payload)
        .then(({ data }) => {
          context.commit(SET_RESTAURANT, data.data)
          resolve(data)
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors)
        })
    })
  },
}

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error
  },
  [SET_RESTAURANTS](state, restaurants) {
    state.restaurants = restaurants
    state.errors = {}
  },
  [SET_FEATURED_RESTAURANTS](state, restaurants) {
    state.featuredRestaurants = restaurants
    state.errors = {}
  },
  [SET_RESTAURANT](state, restaurant) {
    state.currentRestaurant = restaurant
    state.errors = {}
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
